var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6875 0.5C5.90014 0.5 5.14503 0.816071 4.58828 1.37868C4.03153 1.94129 3.71875 2.70435 3.71875 3.5C3.71875 4.29565 4.03153 5.05871 4.58828 5.62132C5.14503 6.18393 5.90014 6.5 6.6875 6.5C7.47486 6.5 8.22997 6.18393 8.78672 5.62132C9.34347 5.05871 9.65625 4.29565 9.65625 3.5C9.65625 2.70435 9.34347 1.94129 8.78672 1.37868C8.22997 0.816071 7.47486 0.5 6.6875 0.5ZM10.3984 8H2.97656C2.38604 8 1.81971 8.23705 1.40215 8.65901C0.984584 9.08097 0.75 9.65326 0.75 10.25C0.75 11.924 1.43133 13.265 2.54906 14.1725C3.64898 15.065 5.12445 15.5 6.6875 15.5C8.25055 15.5 9.72602 15.065 10.8259 14.1725C11.9422 13.265 12.625 11.924 12.625 10.25C12.625 9.65326 12.3904 9.08097 11.9729 8.65901C11.5553 8.23705 10.989 8 10.3984 8Z",
    fill: "#e10f3f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.8c76a45a026c4d0a04f0decee4b12d87.svg";
export { ForwardRef as ReactComponent };